import React from 'react';
//This is for main pages
function Card({ children }) {
  return (
    <div className="max-w-4xl mx-auto pt-12 pb-20">
      <div className="md:mx-8 md:border md:shadow-xl  pb-12 md:px-8">
        {children} 
      </div>
    </div>
  );
}

export default Card;
